var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FForm',{attrs:{"route":"categories","title":"Category","columns":"2","schema":[
    {
      component: 'FInput',
      key: 'name',
      label: 'Name',
      column: 1,
    },
    {
      component: 'FInput',
      key: 'slug',
      label: 'Slug',
      column: 1,
    },
    {
      component: 'FEditor',
      key: 'short_description',
      label: 'Short description',
      column: 1,
    },
    {
      component: 'FEditor',
      key: 'description',
      label: 'Description',
      column: 1,
    },
    {
      component: 'FSelect',
      key: 'filter_id',
      label: 'Filter',
      column: 1,
      items: _vm.filters,
    },
    {
      component: 'FMediaPicker',
      key: 'media_id',
      label: 'Image',
      column: 2,
    },
    {
      component: 'FGalleryPicker',
      key: 'gallery_id',
      label: 'Gallery',
      column: 2,
    },
    {
      component: 'FInput',
      key: 'seo_title',
      label: 'SEO Title (max 80 chars)',
      column: 1
    },
    {
      component: 'FTextarea',
      key: 'seo_description',
      label: 'SEO Description (max 150 chars)',
      column: 1
    },
    {
      component: 'FInput',
      key: 'seo_keywords',
      label: 'SEO Keywords (max 5 sentense/words, separated by comma)',
      column: 1
    } ],"submit":_vm.submit},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }